<template>
  <div class="page-container">
    <div class="verification-card">
      <header class="card-header">
        <div class="logo">✔️</div>
        <h1>Verifikasi Hasil Psikotes</h1>
      </header>

      <div v-if="isLoading" class="loading-state">
        <div class="spinner"></div>
        <p>Memverifikasi data...</p>
      </div>

      <div v-else-if="error" class="error-state">
        <h2>Gagal Verifikasi</h2>
        <p>{{ error }}</p>
        <router-link to="/">Kembali ke Halaman Utama</router-link>
      </div>

      <!-- Di dalam VerificationPage.vue -> <template> -->

      <div v-else-if="result" class="success-state">
        <h2>Hasil Terverifikasi</h2>
        <div class="details-grid">
          <div class="detail-item"><strong>Nama Peserta:</strong><span>{{ result.name }}</span></div>
          <div class="detail-item"><strong>Nomor Tes:</strong><span>{{ result.test_number }}</span></div>
          
          <!-- ============================================ -->
          <!--           TAMBAHKAN BLOK INI DI SINI         -->
          <!-- ============================================ -->
          <div class="detail-item"><strong>Keperluan:</strong><span>{{ result.sim_type }} ({{ result.sim_status }})</span></div>
          <div class="detail-item"><strong>Lokasi Tes:</strong><span>{{ result.test_location }}</span></div>
          <!-- ============================================ -->
          
          <div class="detail-item"><strong>Paket Tes:</strong><span>{{ result.package_name }}</span></div>
          <div class="detail-item"><strong>Tanggal Tes:</strong><span>{{ formatDate(result.test_date) }}</span></div>
        </div>
        <div class="conclusion" :class="conclusionClass">
          Kesimpulan: <strong>{{ result.conclusion }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import apiClient from '@/services/api.js';

const route = useRoute();
const isLoading = ref(true);
const result = ref(null);
const error = ref('');

const conclusionClass = computed(() => {
    if (!result.value || !result.value.conclusion) return '';
    const conclusion = result.value.conclusion.toLowerCase();
    if (conclusion.includes('lulus')) return 'lulus';
    if (conclusion.includes('tidak lulus')) return 'tidak-lulus';
    return 'netral';
});

const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(dateString).toLocaleDateString('id-ID', options);
};

onMounted(async () => {
  const testNumber = route.query.id;
  if (!testNumber) {
    error.value = "Nomor tes tidak ditemukan di URL.";
    isLoading.value = false;
    return;
  }

  try {
    const response = await apiClient.get(`/verify?id=${testNumber}`);
    result.value = response.data;
  } catch (err) {
    error.value = err.response?.data?.detail || "Terjadi kesalahan saat mengambil data.";
    console.error(err);
  } finally {
    isLoading.value = false;
  }
});
</script>

<style scoped>
.page-container { display: flex; justify-content: center; align-items: center; min-height: 100vh; background-color: #f0f2f5; padding: 20px; }
.verification-card { width: 100%; max-width: 600px; background: white; padding: 40px; border-radius: 10px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
.card-header { text-align: center; margin-bottom: 30px; }
.logo { font-size: 40px; color: #1abc9c; }
h1 { margin-top: 10px; }
.loading-state, .error-state, .success-state { text-align: center; }
.details-grid { text-align: left; margin: 20px 0; }
.detail-item { display: flex; justify-content: space-between; padding: 10px 0; border-bottom: 1px solid #eee; }
.conclusion { font-size: 1.2em; margin-top: 20px; padding: 15px; border-radius: 6px; }
.conclusion.lulus { background-color: #d4edda; color: #155724; }
.conclusion.tidak-lulus { background-color: #f8d7da; color: #721c24; }
.conclusion.netral { background-color: #e2e3e5; color: #383d41; }
.spinner { /* ... (salin style spinner dari TestTaker.vue) ... */ }
</style>